module.exports = __webpack_public_path__ + "static/media/road.cc5c2cbb.jpg";